<template lang="html">
  <div class="bill-detail-wrap" v-loading="loading">
    <div class="top same-content">
      <div class="content-title">
        概览
      </div>
      <div class="top-content same-padding">
        <div class="top-item">
          <span>承运方：</span><span>{{ details.carrier }}</span>
        </div>
        <div class="top-item">
          <span>订单数：</span
          ><span>{{ details.general && details.general.orderNoCnt }}</span>
        </div>
        <div class="top-item">
          <span>费用单数：</span
          ><span>{{ details.general && details.general.accrualBasisCnt }}</span>
        </div>
        <div class="top-item">
          <span>账单号：</span><span>{{ billNo }}</span>
        </div>
        <div class="top-item">
          <span>账单生成时间：</span
          ><span>{{
            details.operation && details.operation.createTime | timeFormat
          }}</span>
        </div>
        <div class="top-item">
          <span>金额：</span
          ><span>{{ details.general && details.general.realTotalMoney }}</span>
        </div>
        <div class="top-item">
          <span>已付金额：</span
          ><span>{{ details.general && details.general.processedMoney }}</span>
        </div>
        <div
          class="top-item"
          v-if="
            details.general &&
              details.general.receiptAndPaymentStatus === '未付款'
          "
        >
          <span>待付金额：</span
          ><span>{{ details.general && details.general.pendingMoney }}</span>
        </div>
        <div class="top-item">
          <span>状态：</span
          ><span>{{
            details.general && details.general.receiptAndPaymentStatus
          }}</span>
        </div>

        <div class="top-item">
          <span>流水：</span
          ><span
            :class="[isOld ? '' : 'link-url']"
            @click="toRunningAccountCnt"
            >{{ details.general && details.general.runningAccountCnt }}</span
          >
        </div>
      </div>
    </div>
    <div class="bottom same-content">
      <div class="content-title">
        明细
      </div>
      <div class="same-padding bottom-content">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="name" label="费用名称" align="center">
          </el-table-column>
          <el-table-column prop="totalMoney" label="费用金额" align="center">
          </el-table-column>
          <el-table-column prop="accrualBasisNo" label="费用号" align="center">
            <template slot-scope="scope">
              <span
                :class="[isOld ? '' : 'link-url']"
                @click="toCost(scope.row.accrualBasisNo)"
                >{{ scope.row.accrualBasisNo }}</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      tableData: [],
      billNo: this.$route.params.billNo,
      details: {},
      loading: false,
      isOld: this.$route.query.isOld
    };
  },
  computed: {},
  created() {
    this.getDetails();
  },
  methods: {
    async getDetails() {
      this.loading = true;
      let { data } = await this.$http.post(
        `/shipper/order-shipper/${
          this.isOld ? "former-bill-detail" : "bill-detail"
        }`,
        qs.stringify({
          billNo: this.billNo
        })
      );
      this.details = data;
      this.tableData = data.detailed;
      this.loading = false;
    },
    toRunningAccountCnt() {
      if (this.isOld) return;
      this.$router.push({
        name: "flowingWater",
        query: { billNo: this.details.general.billNo }
      });
    },
    toCost(accrualBasisNo) {
      if (this.isOld) return;
      this.$router.push({
        name: "cost",
        query: { accrualBasisNo }
      });
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.bill-detail-wrap {
  border: 1px solid #e0e0e0;
  margin-top: 40px;
  min-height: calc(100vh - 388px);
  .top {
    border-bottom: 1px solid #e0e0e0;
    .top-content {
      display: flex;
      flex-wrap: wrap;
      .top-item {
        width: 50%;
        line-height: 30px;
      }
    }
  }
  .bottom {
    .bottom-content {
      padding-right: 40px;
      padding-bottom: 10px;
    }
  }
  .same-content {
    padding: 20px;
    .content-title {
      font-size: 16px;
      font-weight: bold;
    }
    .same-padding {
      padding-left: 40px;
      padding-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/bill/detail/index.vue